import { render, staticRenderFns } from "./ReportNotifyRecord.vue?vue&type=template&id=5038e90a&"
import script from "./ReportNotifyRecord.vue?vue&type=script&lang=js&"
export * from "./ReportNotifyRecord.vue?vue&type=script&lang=js&"
import style0 from "./ReportNotifyRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports